import { assetFilterAtoms } from '@/features/assets/filters.ts';
import { clientFilterAtoms } from '@/features/data/clients/filters.ts';
import { locationFilterAtoms } from '@/features/data/locations/filters.ts';
import { projectFilterAtoms } from '@/features/data/projects/filters.ts';
import { templateFilterAtoms } from '@/features/data/templates/filters.ts';
import { salesOrderFilterAtoms } from '@/features/finance/sales-orders/filters.ts';
import { liftFilterAtoms } from '@/features/lifts/filters.ts';
import { workOrderFilterAtoms } from '@/features/work-orders/filters.ts';
import type { Atom } from 'jotai';

export type DevtoolsFilterAtomEntry<
  TValues extends Record<string, unknown> = Record<string, unknown>,
> = {
  id: string;
  label: string;
  route: string;
  valuesAtom: Atom<TValues>;
};

function filterAtomEntry<TValues extends Record<string, unknown>>(
  entry: DevtoolsFilterAtomEntry<TValues>,
) {
  return entry;
}

export const DEVTOOLS_FILTER_ATOMS = [
  filterAtomEntry({
    id: 'assets',
    label: 'Assets',
    route: '/assets',
    valuesAtom: assetFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'work-orders',
    label: 'Work Orders',
    route: '/work-orders',
    valuesAtom: workOrderFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'lifts',
    label: 'Big Rentz Lifts',
    route: '/big-rentz-lifts',
    valuesAtom: liftFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'clients',
    label: 'Clients',
    route: '/data/clients',
    valuesAtom: clientFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'projects',
    label: 'Projects',
    route: '/data/projects',
    valuesAtom: projectFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'locations',
    label: 'Locations',
    route: '/data/locations',
    valuesAtom: locationFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'templates',
    label: 'Templates',
    route: '/data/templates',
    valuesAtom: templateFilterAtoms.valuesAtom,
  }),
  filterAtomEntry({
    id: 'sales-orders',
    label: 'Sales Orders',
    route: '/finance/sales-orders',
    valuesAtom: salesOrderFilterAtoms.valuesAtom,
  }),
] as const;
